import { EmbeddedRecordsMixin } from '@warp-drive/legacy/serializer/rest';
import PostsSerializer from '@linc-technologies/linced-common/serializers/posts/base';

export default class Globalnotice extends PostsSerializer.extend(
  EmbeddedRecordsMixin,
) {
  attrs = {
    mediaIds: { serialize: 'ids' },
  };

  payloadKeyFromModelName(modelName) {
    return super
      .payloadKeyFromModelName(modelName)
      .replace('globalnotice', 'post');
  }

  modelNameFromPayloadKey(key) {
    return super.modelNameFromPayloadKey(key.replace('post', 'globalnotice'));
  }
}
